<template>
    <div>
      <v-row dense>
        <v-col cols="1" v-for="(day, i) in days_short" :key="i">
          <v-label><span class="day-labels ml-1">{{ day }}</span></v-label>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="1" v-for="(day, i) in days" :key="i">
          <v-simple-checkbox dense v-model="days[i]" :color="color" hide-details v-on:input="callChange(i)" :class="{'margin-left-2': field !== 'other_planning_days'}"></v-simple-checkbox>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
    export default {
      props: {
        days: Array,
        field: String,
        color: String
      },
      data() {
        return {
          days_short: ["All","Su","Mo","Tu","We","Th","Fr","Sa"],
        }
      }, 
      methods:{        
        callChange(i){
          if (i===0){
            for(let i=0; i<=this.days.length; i++){
              if(i>0) {
                if(this.days[0]) {
                  this.days[i-1]=true;
                } else {
                  this.days[i-1]=false;
                }            
              }
            }
          } else{
            this.days[0]=false;            
          }
          this.$emit('updateData', {"field": this.field, "value": this.days});
        },    
      }
    }
  </script>
  
  <style scoped>
    .day-labels {
      font-weight: 600 !important;
    }
    .margin-left-2 {
      margin-left: 2px;
    }
  </style>